(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tur/start-subscription/views/bankcard-payment.js') >= 0) return;  svs.modules.push('/components/tur/start-subscription/views/bankcard-payment.js');
(function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.tur=_svs.tur||{};
_svs.tur.start_subscription=_svs.tur.start_subscription||{};
_svs.tur.start_subscription.templates=_svs.tur.start_subscription.templates||{};
svs.tur.start_subscription.templates.bankcard_payment = Handlebars.template({"1":function(container,depth0,helpers,partials,data) {
    return "";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "\n<div class=\"padding-2 f-body line-height-150 pay-subscription-bankcard-wrapper\">\n"
    + ((stack1 = container.invokePartial(lookupProperty(partials,"components-tur-start_subscription-payment_info"),depth0,{"name":"components-tur-start_subscription-payment_info","data":data,"indent":"  ","helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "")
    + "  <div class=\"data-hj-suppress\">\n    "
    + ((stack1 = (lookupProperty(helpers,"accountservices")||(depth0 && lookupProperty(depth0,"accountservices"))||container.hooks.helperMissing).call(depth0 != null ? depth0 : (container.nullContext || {}),"swedbankpay-checkout",{"name":"accountservices","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":5,"column":4},"end":{"line":5,"column":68}}})) != null ? stack1 : "")
    + "\n  </div>\n</div>";
},"usePartial":true,"useData":true});
Handlebars.partials['components-tur-start_subscription-bankcard_payment'] = svs.tur.start_subscription.templates.bankcard_payment;
})(svs, Handlebars);


 })(window);